import { z } from "zod";

import { API_TYPES } from "../api";

export const supportArticleSchema = z.object({
  id: z.string(),
  type: z.literal(API_TYPES.supportArticle),
  attributes: z.object({
    title: z.string(),
    category: z.string(),
    distributionUrl: z.string(),
  }),
});
export type SupportArticle = z.infer<typeof supportArticleSchema>;
